import React from 'react';
import { FaChartBar, FaChartLine, FaChartPie, FaChartArea, FaTable } from 'react-icons/fa';
import { normalizeChartType } from './echarts/chartTypeRegistry';

const CHART_TYPE_LABELS = {
  bar: 'Column Chart',
  horizontalBar: 'Bar Chart',
  stackedColumn: 'Stacked Column',
  stackedBar: 'Stacked Bar',
  line: 'Line Chart',
  mixed: 'Mixed (Bar + Line)',
  area: 'Area Chart',
  donut: 'Donut Chart',
  pie: 'Pie Chart',
  funnel: 'Funnel Chart',
  scatter: 'Scatter Chart',
  table: 'Table',
};

export function getChartTypeDisplayLabel(chartType) {
  const key = normalizeChartType(chartType || 'bar');
  return CHART_TYPE_LABELS[key] || 'Chart';
}

export function getChartTypeDisplayIcon(chartType) {
  const key = normalizeChartType(chartType || 'bar');
  switch (key) {
    case 'line':
    case 'mixed':
      return <FaChartLine />;
    case 'pie':
    case 'donut':
    case 'funnel':
      return <FaChartPie />;
    case 'area':
      return <FaChartArea />;
    case 'table':
      return <FaTable />;
    case 'scatter':
      return <FaChartLine />;
    default:
      return <FaChartBar />;
  }
}
